export default __webpack_public_path__ + "static/media/2264a265b36dcf9f76605d9d980752051581600910404.6bc33cf6.webp";